import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createSlots as _createSlots, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_steps = _resolveComponent("steps")!
  const _component_gebaeudedaten_ubersicht = _resolveComponent("gebaeudedaten-ubersicht")!
  const _component_titel_zelle = _resolveComponent("titel-zelle")!
  const _component_zelle = _resolveComponent("zelle")!
  const _component_zeile = _resolveComponent("zeile")!
  const _component_abschluss = _resolveComponent("abschluss")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_steps, {
      items: _ctx.navItems,
      active: 4,
      onGotoPage: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('goto-page', $event)))
    }, null, 8, ["items"]),
    _createVNode(_component_abschluss, {
      produkt: "vgv",
      "zeige-versichertes-objekt": true,
      "zusaetzliche-SbLw": _ctx.zusaetzlicheSbLw,
      "zeige-tarif": true,
      onNextPage: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('next-page', $event))),
      onGotoPage: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('goto-page', $event)))
    }, _createSlots({
      "versichertes-objekt": _withCtx(() => [
        _createVNode(_component_gebaeudedaten_ubersicht)
      ]),
      "angaben-bestaetigen": _withCtx(() => [
        _createTextVNode(" Der Antrag wurde gemäß meiner Angaben erstellt. " + _toDisplayString(_ctx.iddText) + " Auf eine Beratung habe ich verzichtet und damit auf den Schadenersatzanspruch nach §6, Abs. 5 VVG. ", 1)
      ]),
      _: 2
    }, [
      (_ctx.hatZusatzmodule)
        ? {
            name: "zusatzmodule",
            fn: _withCtx(() => [
              _cache[3] || (_cache[3] = _createElementVNode("br", null, null, -1)),
              _createTextVNode(_toDisplayString(_ctx.zusatzModule), 1)
            ]),
            key: "0"
          }
        : undefined,
      (_ctx.piniaStore.state.tarifinformationen.extraSelbstbeteiligung)
        ? {
            name: "zusaetzliche-selbstbeteiligung",
            fn: _withCtx(() => [
              _createVNode(_component_zeile, { class: "u-mar-t-2" }, {
                default: _withCtx(() => [
                  _createVNode(_component_titel_zelle, {
                    breite: 3,
                    class: "o-grid__cell--4",
                    "ausrichtung-responsiv": false,
                    "vertikal-zentrieren": false
                  }, {
                    default: _withCtx(() => _cache[4] || (_cache[4] = [
                      _createTextVNode(" Zu­sätz­liche Selbst­be­teili­gung je Grund­ge­fahr-Schaden  ")
                    ])),
                    _: 1,
                    __: [4]
                  }),
                  _createVNode(_component_zelle, {
                    breite: 9,
                    class: "o-grid__cell--8",
                    "data-cy": "zusaetzlicheSb"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("strong", null, _toDisplayString(_ctx.formatCurrency(_ctx.piniaStore.state.tarifinformationen.extraSelbstbeteiligung)), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            key: "1"
          }
        : undefined
    ]), 1032, ["zusaetzliche-SbLw"])
  ], 64))
}